import { alpha } from '@mui/material/styles';

import { theme } from '@/design-system';

import { pipelineColors } from '../../constants';
import type { PipelineColumn } from '../../types';

const STAGE_ORDER_COLORS = [
  pipelineColors.blue,
  pipelineColors.purple,
  pipelineColors.amber,
  pipelineColors.lightYellow,
  pipelineColors.teal,
  pipelineColors.green,
  pipelineColors.brown,
] as const;

export const getPipelineStageColor = (column: Pick<PipelineColumn, 'order' | 'terminal'>) => {
  if (column.terminal) return pipelineColors.neutralMuted;
  return STAGE_ORDER_COLORS[column.order % STAGE_ORDER_COLORS.length] ?? theme.colors.white[80];
};

export const getPipelineStageChrome = (column: Pick<PipelineColumn, 'order' | 'terminal'>) => {
  const color = getPipelineStageColor(column);

  return {
    color,
    compactSurface: alpha(color, 0.03),
    compactBorder: alpha(color, 0.06),
    compactBadgeSurface: alpha(color, 0.13),
  };
};

export const getPipelineStageDisplayLabel = (label: string, compact = false) => {
  const normalized = label.trim();
  return compact ? normalized : normalized.toUpperCase();
};
